import authStore from "../stores/authStore";
import { createAPI } from "./istance.api";

export const API = createAPI(authStore);
